import * as type from './ClinicType';

const initialState = {
    clinics: null
};
export const clinicReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_CLINICS.SUCCESS:
            return { ...state, clinics: action.payload };
        case type.CREATE_CLINIC:
            return { ...state, clinics: [action.payload, ...state.clinics] };
        case type.UPDATE_CLINIC: {
            const id = action.payload.id;
            const updateClinic = state.clinics.map((item) =>
                item.id === id ? action.payload : item
            );
            return { ...state, clinics: updateClinic };
        }
        default:
            return state;
    }
};
